import { css } from '@emotion/core'
import {
  BottomBarCommonStyle,
  CommonTxtBoxStyle,
  FloatingBottom,
  NavBottomPadding,
  NavH,
  SafeAreaConstantPadding,
  SafeAreaEnvPadding,
  TxtLimit,
} from '@styles/base.style'
import styled from '@themes/theme'

export const PickBottomFloatingBar = styled.div`
  z-index: 1;
  ${BottomBarCommonStyle};
  .pick-bar-list {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 100%;
    padding: 2px 9px 6px;
    &--item {
      display: flex;
      height: 50px;
      .ico-btn {
        display: inline-flex;
        justify-content: space-between;
        align-items: center;
        width: 90px;
        padding: 0 18px 0 12px;
        &:first-of-type {
          &::after {
            content: '';
            display: block;
            position: absolute;
            top: 50%;
            right: 0;
            transform: translateY(-50%);
            width: 1px;
            height: 14px;
            border-right: 1px solid ${props => props.theme.color.subColor};
          }
        }
        svg {
          width: 36px;
          height: 36px;
          path {
            fill: ${props => props.theme.color.disableBg};
          }
        }
        .num, .like-num {
          font-size: ${props => props.theme.font.large};
          font-weight: ${props => props.theme.fontW.medium};
          color: ${props => props.theme.color.btn};
        }
        &.active {
          svg .fill {
            fill: ${props => props.theme.color.underover};
          }
        }
      }
    }
  }
  &.pc-pick-bottom-floating-bar {
    // 좋아요 버튼
    .ico-btn {
      &:not(.active):hover {
        svg .fill {
          fill: ${props => props.theme.color.disableTxt2};
        }
      }
      &:hover {
        &, .num {
          color: ${props => props.theme.color.disableTxt2};
        }
      }
    }
  }
`
export const GoMatchBtnStyle = css`
  width: 100%;
  height: 60px;
  margin-bottom: ${NavBottomPadding};
  border-radius: 0;
  svg {
    width: 9px;
    margin-left: 4px;
    transform: rotate(-90deg) translate(2px, 2px);
  }
`
export const CompanyPickDetailContentsWrap = styled.div`
  position: relative;
  .team-info-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 24px 0;
    &--item {
      position: relative;
      flex: 1;
      display: flex;
      flex-flow: column;
      align-items: center;
      justify-content: center;
      max-width: calc((100% - 50px) / 2);
      &:nth-of-type(2) {
        max-width: 50px;
      }
      .emblem {
        width: auto;
        height: 45px;
      }
      .team {
        ${TxtLimit};
        display: inline-block;
        max-width: 85%;
        margin-top: 3px;
      }
      .home-tag-img {
        position: absolute;
        top: -2px;
        left: calc(50% - 24px);
        transform: translateX(-50%);
        width: auto;
        height: 21px;
      }
      .vs-bg {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        opacity: .08;
        font-size: 74px;
        color: ${props => props.theme.color.btn};
      }
      .date {
        line-height: 1rem;
        color: ${props => props.theme.color.disableTxt2};
      }
    }
  }
  // 픽 내용 (프리미엄분석가)
  .pick-box {
    padding: 27px;
    text-align: left;
    background: ${props => props.theme.color.mainColor};
    .tit {
      margin-bottom: 18px;
      font-size: ${props => props.theme.font.large};
    }
    .txt {
      * {
        ${CommonTxtBoxStyle};
        line-height: 2.5rem;
        color: ${props => props.theme.color.modalSubBg2};
        font-size: ${props => props.theme.font.title};
        letter-spacing: -0.03rem;
      }
      *:not(strong) {
        font-weight: ${props => props.theme.fontW.medium};
      }
      p > img {
        height: auto !important;
      }
    }
    .line {
      display: block;
      width: 100%;
      height: 1px;
      margin: 30px 0 21px;
      background: ${props => props.theme.color.TP};
    }
    img {
      max-width: 100%;
    }
    .notice-txt {
      opacity: .8;
      margin-bottom: 111px; // 디자인 시안 확정 후 수정
      color: ${props => props.theme.color.disableTxt2};
      font-weight: ${props => props.theme.fontW.medium};
    }
  }
  // 분석가 픽 (프리미엄분석가)
  .pick-item {
    margin: -69px 0 0;
    text-align: left;
    position: relative;
    &--bg {
      position: absolute;
      left: 0;
      bottom: 0;
      width: auto;
      height: 120px;
      max-height: 120px;
      > img {
        position: relative;
        z-index: 1;
        width: auto;
        height: 100%;
        object-fit: cover;
      }
    }
    .pick-info {
      position: relative;
      display: inline-flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      min-height: 58px;
      height: 80px;
      padding: 0 18px 0 94px;
      background: ${props => props.theme.color.subColor2};
      .left {
        display: inline-flex;
        flex-wrap: wrap;
        align-items: center;
        max-width: calc(100% - 60px);
        margin-right: 14px;
        .market-name {
          ${TxtLimit};
          width: 100%;
          font-size: ${props => props.theme.font.medium};
          font-weight: ${props => props.theme.fontW.medium};
          color: ${props => props.theme.color.btn};
          transform: translateY(1px);
        }
        .outcome {
          ${TxtLimit};
          width: 100%;
          font-size: ${props => props.theme.font.title};
        }
        .market-type-wrap {
          width: 100%;
          display: flex;
          align-items: center;
          margin-left: 1px;
          .market-type {
            display: inline-block;
            width: auto;
            height: 14px;
            margin-right: 4px;
            padding: 0 5px;
            border-radius: 4px;
            color: ${props => props.theme.color.mainBg};
            background: ${props => props.theme.color.disableTxt2};
            font-size: ${props => props.theme.font.small};
          }
          .bet-point {
            line-height: 16px;
            font-size: ${props => props.theme.font.medium};
            color: ${props => props.theme.color.underover};
          }
        }
      }
      .right {
        display: inline-flex;
        align-items: center;
        .rate {
          font-size: ${props => props.theme.font.largeNum};
          color: ${props => props.theme.color.yellow};
        }
        .state {
          display: inline-block;
          width: 7px;
          height: 7px;
          margin-left: 2px;
          border-radius: 50%;
          transform: translateY(-13px);
          &.success {
            background: ${props => props.theme.color.secondaryBg};
          }
          &.fail {
            background: ${props => props.theme.color.disableTxt};
          }
          &.cancel {
            background: ${props => props.theme.color.purple};
          }
        }
      }
    }
  }
`
export const PickTip = styled.div`
  margin: 20px 0 18px;
  padding: 0 18px;
  text-align: left;
  color: ${props => props.theme.color.disableTxt2};
  font-weight: ${props => props.theme.fontW.medium};
  .tip-box {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 30px;
    height: 21px;
    transform: translateY(-1px);
    margin-right: 6px;
    color: ${props => props.theme.color.disableTxt2};
    background: ${props => props.theme.color.subColor};
    border-radius: 6px;
  }
  .favorite-btn-active-img {
    width: 9px;
    height: auto;
    opacity: .5;
    margin: 0 1px 1px;
  }
`
export const PickFloatingBtn = styled.div`
  z-index: 1;
  position: fixed;
  bottom: ${FloatingBottom};
  right: 0;
  padding-bottom: ${SafeAreaEnvPadding};
  padding-bottom: ${SafeAreaConstantPadding};
  .pick-floating-btn {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: auto;
    min-width: 81px;
    height: 45px;
    padding: 0 14px;
    border-radius: 50px 0 0 50px;
    background: ${props=> props.theme.color.mainBg};
    font-size: ${props=> props.theme.font.large};
    box-shadow: 0 3px 12px rgba(22, 26, 35, .3);
    &::before {
      content:'';
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: inherit;
      border: 1px solid ${props=> props.theme.color.btn};
      border-right: none;
      opacity: .5;
      border-radius: 50px 0 0 50px;
    }
    .left-item {
      line-height: 30px;
      font-size: inherit;
      margin-right: 9px;
      .favorite-btn-active-img {
        width: 13px;
        height: auto;
        opacity: 1;
        position: absolute;
        margin: 8px 5px;
      }
      .favorite-svg {
        width: auto;
        height: 24px;
        //color: ${props=> props.theme.color.yellow};
        color: transparent;
        transform: translateY(-1px);
        vertical-align: middle;
        path{
          fill: transparent;
        }
        .fill {
          //fill: ${props => props.theme.color.yellow};
          fill: transparent;
        }
      }
    }
    .arrow-svg {
      width: auto;
      height: 5px;
      color: ${props=> props.theme.color.disableTxt2};
      transform: rotate(-90deg);
    }
  }
  &.add-cart-btn {
    bottom: 115px;
    .pick-floating-btn {
      justify-content: flex-start;
      .plus-ico {
        position: relative;
        display: inline-block;
        width: 12px;
        height: 12px;
        margin-right: 6px;
        border-radius: 50%;
        transform: translateY(-5%);
        &::before, &::after {
          content: '';
          display: block;
          position:absolute;
          top: 50%;
          left: 50%;
          transform: translate3d(-50%, -50%, 0) scale(1.5);
          background: ${props => props.theme.color.disableTxt2};
          border-radius: 10px;
        }
        &::before {
          width: 8px;
          height: 1px;
        }
        &::after {
          width: 1px;
          height: 8px;
        }
      }
    }
  }
  // 프리미엄 분석가 페이지 플로팅 버튼
  &.pc-floating-btn {
    position: sticky;
    float: right;
    margin-right: 8px;
  }
  &.disabled {
    .left-item {
      color: ${props => props.theme.color.disableTxt2};
    }
    svg .fill {
      fill: ${props => props.theme.color.subColor};
    }
    .pick-floating-btn {
      .left-item {
        .favorite-btn-active-img {
          opacity: 0;
        }
        .favorite-svg .fill {
          fill: ${props => props.theme.color.subColor};
        }
      }
    }
  }
`
const FavortiePickListBtnH = '36px'
export const FavoritePickListBtn = styled.div`
  position: fixed;
  bottom: calc(${NavH} - (${FavortiePickListBtnH} + 1px));
  right: 0;
  width: 100%;
  height: auto;
  padding-bottom: calc(${SafeAreaEnvPadding} - 1px);
  padding-bottom: calc(${SafeAreaConstantPadding} - 1px);
  cursor: pointer;
  transition: bottom .25s;
  .go-favorite-match {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
    height: ${FavortiePickListBtnH};
    padding: 0 24px;
    color: ${props => props.theme.color.themeTxt};
    font-weight: ${props => props.theme.font.medium};
    overflow: hidden;
    .btn-bg {
      z-index: -1;
      opacity: .95;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: inherit;
      background: ${props => props.theme.color.subColor};
    }
    .favorite-btn-active-img {
      width: 14px;
      height: auto;
      margin: 0 5px;
    }
    .txt {
      transform: translateY(3%);
    }
    .arrow-svg {
      width: auto;
      height: 6px;
      margin-left: 12px;
      color: ${props=> props.theme.color.disableTxt2};
      transform: rotate(-90deg);
    }
  }
  &.active {
    bottom: calc(${NavH} - 1px);
    z-index: 1;
  }
  &:hover {
    .btn-bg {
      opacity: .75;
      background: ${props => props.theme.color.btn};
    }
  }
`
export const CompanyPickImgWrap = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -52%);
  width: 100%;
  height: auto;
  .img-box {
    width: 100%;
    height: auto;
    overflow-x: auto;
    &::-webkit-scrollbar {
      display: block !important;
    }
    img {
      width: auto;
      height: auto;
      max-height: 50vh;
    }
  }
  &.pc {
    width: auto;
    max-width: 100%;
    .img-box {
      width: auto;
      img {
        max-height: 80vh;
      }
    }
  }
`
